export default __webpack_public_path__ + "static/32_31-9fed5a55a89b36af466b7833e6e5a6b6.png";